import { getDefaultLanguage } from './languageHelper';
import { IVoucher } from '@homeserve/vue-api-plugin';
import { getPartnerDetailsResult } from '@homeserve/od-typings/api';

export const partnerFilterWrapper = (partner: getPartnerDetailsResult) => {
  const defaultLanguage = getDefaultLanguage(partner);

  return {
    formatPrice: (
      value: number,
      options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: partner.currency,
      },
      split = false,
    ) => {
      if (!value) {
        return '';
      }

      if (!options.style && !options.currency) {
        options.style = 'currency';
        options.currency = partner.currency;
      }

      const formatter = new Intl.NumberFormat(defaultLanguage, options);

      if (split) {
        return formatter.formatToParts(value);
      }

      return formatter.format(value);
    },
    formatVoucher: (voucher: IVoucher) => {
      if (!voucher) {
        return '';
      }

      if (voucher.type === 'percent') {
        return voucher.amount + '%';
      } else {
        return partnerFilterWrapper(partner).formatPrice(voucher.amount);
      }
    },
  };
};
